import { getYmAnalyticsId } from '@r1-frontend/shared/helpers/getYmId';
import { IRequest } from '@r1-frontend/shared/types/IRequest';

export enum ESendByCallPetitions {
    ProblemNew = 'problem_new',
    RequestNew = 'request_new',
}

export interface ISendByCallParams {
    fio?: string,
    phone?: string,
    phoneId?: string,
    petition: ESendByCallPetitions,
}

export interface ICallback {
    status: number,
    message: string,
}
/**
 * GET-запрос обратного звонка /user/by-call
 * https://master.api-request.sandbox.d2c.r-one.io/docs/v1#/RequestByCall/97236e7264c5c74498176d791577cf75
 */
export const sendByCall = (providerId: number, queryParams: ISendByCallParams): IRequest => {
    return {
        uri: '/v1/user/by-call',
        method: 'GET',
        headers: { providerId: `${providerId}` },
        queryParams: {
            ...queryParams,
            ...getYmAnalyticsId(),
        },
    };
};
